/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type CalendarStatus_person = {
    readonly profile: {
        readonly givenName: string | null;
    } | null;
    readonly " $refType": "CalendarStatus_person";
};
export type CalendarStatus_person$data = CalendarStatus_person;
export type CalendarStatus_person$key = {
    readonly " $data"?: CalendarStatus_person$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"CalendarStatus_person">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CalendarStatus_person",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "UserProfile",
            "kind": "LinkedField",
            "name": "profile",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "givenName",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Person",
    "abstractKey": null
} as any;
(node as any).hash = '3d948b284e7b75eb6159fa98fcfa7d00';
export default node;
